import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
import { Col, Form, Row, Container, ButtonGroup, Button } from "react-bootstrap";
import NumberFormat from "react-number-format";
export var MobilePayTip = function MobilePayTip(props) {
  var index = props.index,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive = props.defaultActive,
      defaultActive = _props$defaultActive === void 0 ? false : _props$defaultActive,
      check = props.check,
      tipAmount = props.tipAmount,
      setGratuity = props.setGratuity,
      tipPercent = props.tipPercent,
      isLoading = props.isLoading,
      setTipPercent = props.setTipPercent,
      payload = props.payload,
      payForOrder = props.payForOrder,
      _props$percentageList = props.percentageList,
      percentageList = _props$percentageList === void 0 ? [] : _props$percentageList; // const tipOptions = percentageList.concat([""])

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      tipSelection = _useState2[0],
      setTipSelection = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      otherTip = _useState4[0],
      setOtherTip = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      otherTipSelected = _useState6[0],
      setOtherTipSelection = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      tipOptions = _useState8[0],
      setTipOptions = _useState8[1];

  var percentage = function percentage(percent) {
    return (percent / 100 * check.TotalToPay).toFixed(2);
  };

  useEffect(function () {
    var options = [];
    percentageList.map(function (percent) {
      var tips = {
        "percentage": percent + "%",
        "amount": (percent / 100 * check.TotalToPay).toFixed(2)
      };
      options.push(tips);
    });
    setTipOptions(options);
  }, [check.TotalToPay]);
  var debounceCallback = useCallback(debounce(function (amount, percent) {
    setTipCall(amount, percent);
  }, 500), []);
  useEffect(function () {
    if (tipSelection === -1) {
      return;
    }

    if (tipSelection === 3) {
      if (!isNaN(otherTip)) {
        debounceCallback(otherTip, 0);
      } else {
        debounceCallback(0, 0);
      }
    } else {
      setOtherTip(undefined);
      debounceCallback(tipOptions[tipSelection].amount, tipOptions[tipSelection].percentage);
    }
  }, [tipSelection, otherTip]);

  function setTipCall(amount, percent) {
    if (amount) {
      setGratuity(parseFloat(amount).toFixed(2));
      setTipPercent(percent);
    } else {
      setGratuity(percentage(percent));
      setTipPercent(percent);
    }
  }

  var rightToLeftFormatter = function rightToLeftFormatter(value) {
    if (!Number(value)) return '';
    var amount = '';

    if (amount.length > 2) {
      amount = parseInt(value).toFixed(2);
    } else {
      amount = (parseInt(value) / 100).toFixed(2);
    }

    return "".concat(amount);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "mobilepay-tip-heading"
  }, /*#__PURE__*/React.createElement("span", null, "Don't forget to add a tip!")), /*#__PURE__*/React.createElement(ButtonGroup, null, Array.isArray(tipOptions) && tipOptions.map(function (tip, index) {
    return /*#__PURE__*/React.createElement(Button, {
      type: "button",
      key: "checkout-tip-".concat(index),
      id: "checkout-tip-".concat(index),
      className: "cb-button-primary-tip ".concat(index === tipSelection ? "is-active" : ""),
      onClick: function onClick() {
        setTipSelection(index);
        setOtherTipSelection(false);
      }
    }, tip.percentage, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, '$' + tip.amount));
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    id: "checkout-other-tip",
    className: "cb-button-primary-tip ".concat(otherTipSelected && (tipSelection === -1 || tipSelection === 3) ? "is-active" : ""),
    onClick: function onClick() {
      setOtherTipSelection(true);
      setTipSelection(3);
    }
  }, "Other", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Add custom tip"))), otherTipSelected && /*#__PURE__*/React.createElement("div", {
    className: "other-tip-amount"
  }, /*#__PURE__*/React.createElement("span", {
    className: "checkout-tip-amount-label"
  }, "Enter tip amount:"), /*#__PURE__*/React.createElement(NumberFormat, {
    className: "checkout-tip-amount-input",
    value: otherTip || "",
    id: "checkout-tip-other-amount",
    placeholder: "0.00",
    step: "0.01",
    decimalSeparator: ".",
    decimalScale: 2,
    maxLength: 8,
    format: rightToLeftFormatter,
    onChange: function onChange(e) {
      return setOtherTip(e.target.value);
    }
  })));
}; // MobilePayTip.propTypes = {
//     // onTipPercentChange: PropTypes.func,
//     onTipAmountChange: PropTypes.func,
//     check: PropTypes.object,
//     defaultTipAmount: PropTypes.number,
//     // otherTip: PropTypes.number
// };